module.exports = __webpack_public_path__ + "img/05.11574187.jpg";